//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../Motion/Motion.SelectFieldData.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"AligningMomentArm",0,"Expression",0],[1,"ConeIndex",0,"Expression",0],[0,"ContactAreaFunction",1,"Motion.MotionFunction",0],[1,"ContactAreaProfile",0,"Motion.SelectFieldData",0],[0,"ContactAreaType",1,0],[0,"CustomizedSolverCurveType",1,0],[0,"CustomizedSolverFunction",1,"Motion.MotionFunction",0],[1,"CustomizedSolverProfile2D",0,"Motion.SelectFieldData",0],[1,"CustomizedSolverProfile3D",0,"Motion.SelectFieldData",0],[0,"DistributedContact",1,0],[0,"FrictionFunction",1,"Motion.MotionFunction",0],[1,"FrictionProfile",0,"Motion.SelectFieldData",0],[1,"FrictionSurfaceProfile",0,"Motion.SelectFieldData",0],[0,"FrictionType",1,0],[1,"NumDivisions",0,"Expression",0],[1,"RelaxationLength",0,"Expression",0],[0,"RollingRadiusType",1,0],[1,"RollingRadiusValue",0,"Expression",0],[1,"SectionHeight",0,"Expression",0],[1,"SectionWidth",0,"Expression",0],[0,"StaticHold",1,0],[0,"SurfaceType",1,0],[1,"TransDampingDeflection",0,"Expression",0],[0,"UseUtilityCurve",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Motion.TirePropertyAdvancedParameters = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.TirePropertyAdvancedParameters";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.TirePropertyAdvancedParameters.RollingType = Object.freeze({
    "None" : "None", "Bias" : "Bias", "Belted" : "Belted"});

SPLM.Motion.TirePropertyAdvancedParameters.FrictType = Object.freeze({
    "Function" : "Function", "Profile" : "Profile"});

SPLM.Motion.TirePropertyAdvancedParameters.ContactType = Object.freeze({
    "Function" : "Function", "Profile" : "Profile"});

SPLM.Motion.TirePropertyAdvancedParameters.CustomizedSolverType = Object.freeze({
    "Function" : "Function", "Profile2D" : "Profile2D", "Profile3D" : "Profile3D"});

SPLM.Motion.TirePropertyAdvancedParameters.SurfType = Object.freeze({
    "Simple" : "Simple", "Hard" : "Hard", "Soil" : "Soil", "VelFrictCurve" : "VelFrictCurve", "FrictCurve" : "FrictCurve", "VelFrictSurface" : "VelFrictSurface", "FrictSurface" : "FrictSurface"});

export default SPLM;